module.exports = __webpack_public_path__ + "static/media/jiosaavn.aa7ce01e.svg";